/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import style              from 'styled-components';
import { transparentize } from 'polished';
import { Colours }        from '../../../styles/variables';
import { Media }          from '../../../styles/utilities';


/*********************************************************************************
 2. Component
 *********************************************************************************/

const wrapperSize = '40px';
const wrapperSizeTablet = '50px';

export const StyledContentIcon = style.div`
  display: none;
  ${Media.Tablet`
    display: block;
    position: absolute;
    background: ${Colours.Carnation};
    border: 4px solid ${Colours.White};
    border-radius: ${wrapperSize};
    box-shadow: 0 1px 1px 0 ${transparentize(0.7, Colours.Tundora)};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${Colours.White};
    top: calc(${wrapperSizeTablet} / 2);
    right: calc(-${wrapperSizeTablet} / 2);
    width: ${wrapperSizeTablet};
    height: ${wrapperSizeTablet};  
  `}
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledContentIcon/index.js